import React, { Component } from 'react';

export default class textInput extends Component {
    render() {
        return (
            <div>
                <label>
                    {this.props.label}
                    <input type="text" name={this.props.name} onChange={this.props.onChange} placeholder={this.props.placeholder} />
                </label>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/textInput.js